import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { ISelectOption } from '@constants/entities/ui';
import useProjectData from '@hooks/useProjectData';
import { transformArrayToOptions } from '@utils/helpers';

const useOwnerOptions = (formKey: string) => {
  const [{ settingsData }] = useProjectData();

  const selectedOwners = useWatch({
    name: formKey,
  }) as ISelectOption[];

  const ownersOptions = useMemo(() => {
    const uniqueSelectedOwners = new Set([
      ...selectedOwners.map(({ value }) => value),
      ...(settingsData?.requirement_owners ?? []),
    ]);

    const ownersArray = Array.from(uniqueSelectedOwners);

    ownersArray.sort((a, b) =>
      a.toString().toLowerCase().localeCompare(b.toString().toLowerCase()),
    );

    return transformArrayToOptions(ownersArray);
  }, [settingsData, selectedOwners]);

  return { ownersOptions };
};

export default useOwnerOptions;
